import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import LogoFooter from './partials/LogoFooter';
import FooterNav from './partials/FooterNav';
import FooterSocial from './partials/FooterSocial';

const propTypes = {
  topOuterDivider: PropTypes.bool,
  topDivider: PropTypes.bool
}

const defaultProps = {
  topOuterDivider: false,
  topDivider: false
}

const Footer = ({
  className,
  topOuterDivider,
  topDivider,
  ...props
}) => {

  const classes = classNames(
    'site-footer center-content-mobile',
    topOuterDivider && 'has-top-divider',
    className
  );

  return (
    <footer
      {...props}
      className={classes}
    >
      <div className="container">
        <div className={classNames('site-footer-inner row', topDivider && 'has-top-divider')}>
          <div className='col-12 col-md-6 cont-left-footer'>
            <div className="footer-top space-between text-xxs">
              <LogoFooter />
            </div>
            <div className="footer-copyright">Carrera 23 # 37 - 63 Bucaramanga, Santander, Colombia </div>
            <div className="footer-copyright">PBX (607) 6970241, Línea Gratuita: 018000180527</div>
            <div className="footer-copyright">3187070030</div>
            <div className="footer-copyright">info@cdmb.gov.co</div>
            <div className="footer-copyright">Notificaciones judiciales</div>
            <div className="footer-copyright">notificaciones.judiciales@cdmb.gov.co</div>
          </div>
          <div className='col-12 col-md-6 cont-right-footer'>
            <div className="footer-copyright">Horario</div>
            <div className="footer-copyright">lunes a viernes de 7:30 a.m. a 12 m y 2 p.m. a 6 p.m.</div>
            <div className="footer-copyright">Laboratorio de Aguas y Suelos</div>
            <div className="footer-copyright">(607) 6970241 ext 1070,</div>
            <div className="footer-copyright">Lunes a Viernes de 7:30 a.m a 4 p.m.</div>
            <div className="footer-top space-between text-xxs">
              <FooterSocial />
            </div>
            <div className="footer-copyright">Creado por
              <a target="_blank" href="https://www.facebook.com/mapasysistemas/"> Mapas y Sistemas SAS</a>.
              Todos los derechos reservados</div>
            {/* <div className="footer-bottom space-between text-xxs">
              <FooterNav />
            </div> */}
          </div>
        </div>
      </div>
    </footer>
  );
}

Footer.propTypes = propTypes;
Footer.defaultProps = defaultProps;

export default Footer;